import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'

class HolidayPriceAdd extends React.Component {
  state = {
    date: '',
    price: '',
    isSaving: false,
    isData: false,
    Edit: false,
  }

  componentDidMount() {
    const today = new Date().toISOString().slice(0, 10)
    this.setState({ startingDate: today })
    setTimeout(() => {
      if (this.props.id) {
        this.getPriceDetails()
      }
    }, 100)
  }

  getPriceDetails = async () => {
    await axios
      .get(Constant.getAPI() + `/holiday-price/get-price-details/${this.props.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({ ...res?.data?.data })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  onSaveData = () => {
    var that = this

    let data = {
      date: this.state.date,
      price: this.state.price,
      source_id: this.props.source_id,
    }

    that.setState({ isData: true })

    if (this.props.id) {
      data.id = this.props.id
      axios
        .put(Constant.getAPI() + '/holiday-price/update-price', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Updated !', `Price has been Updated`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/holiday-price/add-price', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          that.setState({ isData: false })
          if (res.status === 200) {
            Swal.fire('Added !', `Price has been Added`, 'success')
            window.history.back()
          }
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Date</label>
                <div className="col-sm-9">
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    id="date"
                    placeholder={`Date`}
                    onChange={this.handleChange}
                    value={this.state.date}
                    min={this.state?.startingDate}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-sm-3 col-form-label">Price</label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    className="form-control"
                    name="price"
                    id="price"
                    placeholder={`Price`}
                    onChange={this.handleChange}
                    value={this.state.price}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isData ? (
              <button className="btn btn-grd-disabled mr-2">Saving...!</button>
            ) : (
              <button
                onClick={this.onSaveData}
                className="btn btn-grd-disabled mr-2"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
            <Link
              to={`/holiday-price/${this.props.source_id}`}
              className="btn btn-outline-dark"
            >
              Cancel
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default HolidayPriceAdd
